import { RouterLink } from '@rideiq/shared/components';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const CloseButton = styled(RouterLink)`
  display: inline-flex;
  margin-left: auto;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;
  flex-shrink: 0;

  &:hover {
    background: #ddebfa;
    svg {
      color: ${colorTokens.text.hover};
    }
  }

  &:focus-visible {
    outline: 2px solid ${colorTokens.primary.main};
    outline-offset: 2px;
  }
`;
